import { useMutation } from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import { LogApiService } from 'features/log/api/log-api.services';
import { queryClient } from 'providers';

import { LogQueryKeys } from './query-keys';
const { ApporveReject } = LogApiService();

export const useApproveReject = () => {
  const { message } = App.useApp();

  return useMutation(
    (payload:any) => {
      return ApporveReject(payload);
    },
    {
      onError: (error) => {
        const uiMessage = handleError(error);

        message.error(uiMessage);
      },
      onSuccess: (data:any) => {
        queryClient.invalidateQueries({
          queryKey: LogQueryKeys.lists(),
        });
        message.success(data?.customMessage)
      }
    },
  );
};










